/**
 * 💜 DEVIENS IRRÉSISTIBLE - Ta version canon de toi !
 * 
 * Fais péter ta plus belle photo et laisse la MAGIE te transformer
 * en bombe atomique ! 🔥 Beau gosse / Belle gosse garanti !
 * 
 * 15 styles artistiques pour révéler ton charme caché ✨
 */

import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Sparkles, ChevronLeft, ChevronRight, Wand2, RefreshCw,
  Check, X, Loader2, Save, History, Heart, Camera, Upload, ImagePlus
} from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// 🎨 STYLES D'AVATAR DISPONIBLES (avec descriptions fun)
const AVATAR_STYLES = [
  { id: 'realistic', name: '📸 Canon Réaliste', description: 'Toi, mais en encore plus beau/belle !', color: 'from-gray-500 to-gray-700' },
  { id: 'anime', name: '🎌 Mode Manga', description: 'Deviens le héros de ton anime !', color: 'from-pink-500 to-purple-500' },
  { id: 'comic', name: '🦸 Super-Héros', description: 'Style Marvel/DC, cape en option !', color: 'from-blue-500 to-red-500' },
  { id: 'fantasy', name: '⚔️ Légende Épique', description: 'Roi/Reine d\'un monde fantastique !', color: 'from-amber-500 to-orange-600' },
  { id: 'watercolor', name: '🎨 Poésie Aquarelle', description: 'Doux comme un rêve éveillé...', color: 'from-cyan-400 to-blue-400' },
  { id: 'van_gogh', name: '🌻 Nuit Étoilée', description: 'Van Gogh aurait kiffé te peindre !', color: 'from-yellow-500 to-blue-600' },
  { id: 'pixel', name: '👾 Héros 8-Bits', description: 'Retro gaming vibes !', color: 'from-green-500 to-emerald-600' },
  { id: 'cyberpunk', name: '🌃 Futur Néon', description: 'Badass cyberpunk, tu gères !', color: 'from-purple-600 to-cyan-400' },
  { id: 'steampunk', name: '⚙️ Inventeur Fou', description: 'Engrenages et classe victorienne !', color: 'from-amber-600 to-stone-500' },
  { id: 'neon', name: '💜 Glow Up', description: 'Tu brilles de mille feux !', color: 'from-fuchsia-500 to-violet-600' },
  { id: 'oil_painting', name: '🖼️ Œuvre d\'Art', description: 'Digne d\'un musée, rien que ça !', color: 'from-amber-700 to-red-800' },
  { id: 'sketch', name: '✏️ Coup de Crayon', description: 'Dessiné avec amour ❤️', color: 'from-gray-400 to-gray-600' },
  { id: 'pop_art', name: '🎭 Pop Star', description: 'Andy Warhol t\'aurait adoré !', color: 'from-red-500 to-yellow-400' },
  { id: 'chibi', name: '🥰 Trop Mignon', description: 'Kawaii overload ! UwU', color: 'from-pink-400 to-rose-400' },
  { id: 'disney', name: '✨ Prince/Princesse', description: 'Ton conte de fées commence !', color: 'from-blue-400 to-purple-400' },
];

// Options de personnalisation
const SKIN_TONES = [
  { id: 'very_light', name: 'Porcelaine', color: '#FFEBD9' },
  { id: 'light', name: 'Claire', color: '#F5D6BA' },
  { id: 'medium', name: 'Médium', color: '#D4A574' },
  { id: 'tan', name: 'Bronzée', color: '#B8763E' },
  { id: 'brown', name: 'Brune', color: '#8B5A2B' },
  { id: 'dark', name: 'Foncée', color: '#5D3A1A' },
];

const HAIR_COLORS = [
  { id: 'black', name: 'Noir', color: '#1a1a1a' },
  { id: 'dark_brown', name: 'Brun foncé', color: '#3d2314' },
  { id: 'brown', name: 'Châtain', color: '#6b4423' },
  { id: 'light_brown', name: 'Châtain clair', color: '#a0522d' },
  { id: 'blonde', name: 'Blond', color: '#daa520' },
  { id: 'platinum', name: 'Platine', color: '#e8e4c9' },
  { id: 'ginger', name: 'Roux', color: '#b7410e' },
  { id: 'red', name: 'Rouge', color: '#8b0000' },
  { id: 'pink', name: 'Rose', color: '#ff69b4' },
  { id: 'purple', name: 'Violet', color: '#8b008b' },
  { id: 'blue', name: 'Bleu', color: '#4169e1' },
  { id: 'green', name: 'Vert', color: '#228b22' },
];

const HAIR_STYLES = {
  male: [
    { id: 'short', name: 'Court' },
    { id: 'medium', name: 'Mi-long' },
    { id: 'long', name: 'Long' },
    { id: 'curly', name: 'Bouclé' },
    { id: 'afro', name: 'Afro' },
    { id: 'bald', name: 'Chauve' },
    { id: 'mohawk', name: 'Crête' },
    { id: 'undercut', name: 'Undercut' },
  ],
  female: [
    { id: 'short', name: 'Court' },
    { id: 'medium', name: 'Mi-long' },
    { id: 'long', name: 'Long' },
    { id: 'curly', name: 'Bouclé' },
    { id: 'wavy', name: 'Ondulé' },
    { id: 'straight', name: 'Lisse' },
    { id: 'braids', name: 'Tresses' },
    { id: 'ponytail', name: 'Queue de cheval' },
  ],
};

const EYE_COLORS = [
  { id: 'brown', name: 'Marron', color: '#5D3A1A' },
  { id: 'dark_brown', name: 'Brun foncé', color: '#3d2314' },
  { id: 'hazel', name: 'Noisette', color: '#8E7618' },
  { id: 'green', name: 'Vert', color: '#2E8B57' },
  { id: 'blue', name: 'Bleu', color: '#4169E1' },
  { id: 'gray', name: 'Gris', color: '#708090' },
  { id: 'amber', name: 'Ambre', color: '#FFBF00' },
  { id: 'violet', name: 'Violet', color: '#8A2BE2' },
];

const MOODS = [
  { id: 'friendly', name: '😊 Sympa', emoji: '😊' },
  { id: 'mysterious', name: '😏 Mystérieux', emoji: '😏' },
  { id: 'confident', name: '😎 Confiant', emoji: '😎' },
  { id: 'playful', name: '😜 Joueur', emoji: '😜' },
  { id: 'romantic', name: '🥰 Romantique', emoji: '🥰' },
  { id: 'serious', name: '😤 Sérieux', emoji: '😤' },
  { id: 'happy', name: '😄 Joyeux', emoji: '😄' },
];

const ACCESSORIES = [
  { id: 'glasses', name: '👓 Lunettes' },
  { id: 'sunglasses', name: '🕶️ Solaires' },
  { id: 'earrings', name: '💎 Boucles' },
  { id: 'necklace', name: '📿 Collier' },
  { id: 'hat', name: '🎩 Chapeau' },
  { id: 'headphones', name: '🎧 Casque' },
  { id: 'crown', name: '👑 Couronne' },
  { id: 'flowers', name: '🌸 Fleurs' },
];

// 🎨 COMPOSANT PRINCIPAL
export default function AvatarCreator({ onSave, onClose, customerId, isDarkMode = true, existingAvatar = null }) {
  // États
  const [currentStep, setCurrentStep] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedAvatar, setGeneratedAvatar] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [avatarHistory, setAvatarHistory] = useState([]);
  
  // 📸 NOUVEAU : Mode photo
  const [creationMode, setCreationMode] = useState(null); // 'scratch' ou 'photo'
  const [userPhoto, setUserPhoto] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [photoAnalysis, setPhotoAnalysis] = useState(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const fileInputRef = useRef(null);
  
  // Configuration de l'avatar
  const [style, setStyle] = useState('anime');
  const [gender, setGender] = useState('female');
  const [skinTone, setSkinTone] = useState('medium');
  const [hairColor, setHairColor] = useState('brown');
  const [hairStyle, setHairStyle] = useState('long');
  const [eyeColor, setEyeColor] = useState('brown');
  const [mood, setMood] = useState('friendly');
  const [selectedAccessories, setSelectedAccessories] = useState([]);
  const [customDescription, setCustomDescription] = useState('');

  // Étapes du wizard - Mode "from scratch" (ton chaleureux !)
  const scratchSteps = [
    { id: 'style', title: '🎨 C\'est quoi ton délire ?', subtitle: '15 univers pour révéler ton charme !' },
    { id: 'gender', title: '👤 Dis-moi qui tu es !', subtitle: 'Beau gosse ou belle gosse ?' },
    { id: 'appearance', title: '✨ Montre-moi ton style', subtitle: 'Peau, cheveux, regard de braise...' },
    { id: 'extras', title: '🎭 La touche finale', subtitle: 'Expression & petits plus qui tuent !' },
    { id: 'generate', title: '🔥 C\'est parti mon kiki !', subtitle: 'La magie opère... ✨' },
  ];
  
  // Étapes du wizard - Mode "from photo" (encore plus punchy !)
  const photoSteps = [
    { id: 'photo', title: '📸 Fais péter ta photo !', subtitle: 'Selfie ou galerie, à toi de jouer !' },
    { id: 'style', title: '🎨 Quel style te fait vibrer ?', subtitle: 'Choisis ta transformation magique !' },
    { id: 'generate', title: '🔥 ABRACADABRA !', subtitle: 'Tu vas être CANON 🔥' },
  ];
  
  // Sélectionner les étapes selon le mode
  const steps = creationMode === 'photo' ? photoSteps : scratchSteps;

  // Cleanup camera on unmount
  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  // Charger l'historique
  useEffect(() => {
    if (customerId) {
      loadHistory();
    }
  }, [customerId]);

  const loadHistory = async () => {
    try {
      const response = await fetch(`${API_URL}/api/avatar/history/${customerId}`);
      if (response.ok) {
        const data = await response.json();
        setAvatarHistory(data.avatars || []);
      }
    } catch (error) {
      console.error('Erreur chargement historique:', error);
    }
  };

  // 📸 FONCTIONS CAMERA/PHOTO
  const startCamera = async () => {
    try {
      const constraints = {
        video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 640 } },
        audio: false
      };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.onloadedmetadata = () => {
          videoRef.current.play().catch(err => console.error('Erreur lecture vidéo:', err));
        };
      }
      setShowCamera(true);
      toast.success('📸 Caméra activée !');
    } catch (err) {
      console.error('Erreur caméra:', err);
      toast.error("Impossible d'accéder à la caméra");
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    setShowCamera(false);
  };

  const takePhoto = () => {
    if (videoRef.current && canvasRef.current) {
      const canvas = canvasRef.current;
      const video = videoRef.current;
      if (video.readyState !== video.HAVE_ENOUGH_DATA) {
        toast.error('La caméra n\'est pas prête');
        return;
      }
      canvas.width = 512;
      canvas.height = 512;
      const ctx = canvas.getContext('2d');
      const size = Math.min(video.videoWidth, video.videoHeight);
      const x = (video.videoWidth - size) / 2;
      const y = (video.videoHeight - size) / 2;
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(video, x, y, size, size, 0, 0, 512, 512);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      const photoData = canvas.toDataURL('image/jpeg', 0.85);
      setUserPhoto(photoData);
      stopCamera();
      toast.success('📸 Photo prise ! Tu es magnifique 💜');
    }
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) {
      toast.error('Image trop lourde (max 10 Mo)');
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 512;
        canvas.height = 512;
        const ctx = canvas.getContext('2d');
        const size = Math.min(img.width, img.height);
        const x = (img.width - size) / 2;
        const y = (img.height - size) / 2;
        ctx.drawImage(img, x, y, size, size, 0, 0, 512, 512);
        const resizedPhoto = canvas.toDataURL('image/jpeg', 0.85);
        setUserPhoto(resizedPhoto);
        toast.success('📸 Photo importée ! 💜');
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  // Toggle accessoire
  const toggleAccessory = (accId) => {
    setSelectedAccessories(prev => 
      prev.includes(accId) 
        ? prev.filter(a => a !== accId)
        : [...prev, accId]
    );
  };

  // Générer l'avatar DEPUIS PHOTO
  const generateAvatarFromPhoto = async () => {
    if (!userPhoto) {
      toast.error('Prends d\'abord une photo !');
      return;
    }
    setIsGenerating(true);
    setGeneratedAvatar(null);
    
    try {
      const response = await fetch(`${API_URL}/api/avatar/generate-from-photo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId,
          photoData: userPhoto,
          style,
        }),
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erreur de génération');
      }
      
      const data = await response.json();
      setGeneratedAvatar(data);
      setPhotoAnalysis(data.analysis);
      loadHistory();
      toast.success('🎨 Avatar généré depuis ta photo ! Tu es CANON 🔥');
      
    } catch (error) {
      console.error('Erreur génération:', error);
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setIsGenerating(false);
    }
  };

  // Générer l'avatar avec la MAGIE (mode from scratch)
  const generateAvatar = async () => {
    setIsGenerating(true);
    setGeneratedAvatar(null);
    
    try {
      const response = await fetch(`${API_URL}/api/avatar/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId,
          style,
          gender,
          description: customDescription,
          skinTone,
          hairColor,
          hairStyle,
          eyeColor,
          mood,
          accessories: selectedAccessories,
        }),
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erreur de génération');
      }
      
      const data = await response.json();
      setGeneratedAvatar(data);
      loadHistory(); // Rafraîchir l'historique
      toast.success('🎨 Avatar généré avec succès !');
      
    } catch (error) {
      console.error('Erreur génération:', error);
      toast.error(`Erreur: ${error.message}`);
    } finally {
      setIsGenerating(false);
    }
  };

  // Sauvegarder l'avatar dans le profil
  const saveToProfile = async () => {
    if (!generatedAvatar) return;
    
    try {
      const response = await fetch(`${API_URL}/api/avatar/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId,
          avatarId: generatedAvatar.avatarId,
          imageData: generatedAvatar.imageData,
        }),
      });
      
      if (response.ok) {
        toast.success('💜 Avatar sauvegardé sur ton profil !');
        onSave?.({
          avatarImage: generatedAvatar.imageData,
          avatarId: generatedAvatar.avatarId,
          style: generatedAvatar.style,
        });
        onClose?.();
      }
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  // Composant de sélection de couleur
  const ColorPicker = ({ options, value, onChange, label }) => (
    <div className="space-y-2">
      <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        {label}
      </label>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.id}
            onClick={() => onChange(opt.id)}
            className={`w-10 h-10 rounded-full border-2 transition-all hover:scale-110 ${
              value === opt.id ? 'ring-2 ring-purple-500 ring-offset-2 scale-110' : ''
            }`}
            style={{ 
              backgroundColor: opt.color,
              borderColor: value === opt.id ? '#a855f7' : isDarkMode ? '#374151' : '#d1d5db'
            }}
            title={opt.name}
          />
        ))}
      </div>
    </div>
  );

  // Composant de sélection d'option
  const OptionGrid = ({ options, value, onChange, columns = 4 }) => (
    <div className={`grid gap-2`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {options.map((opt) => (
        <button
          key={opt.id}
          onClick={() => onChange(opt.id)}
          className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
            value === opt.id
              ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg scale-105'
              : isDarkMode
                ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {opt.name}
        </button>
      ))}
    </div>
  );

  // Rendu du contenu de chaque étape
  const renderStepContent = () => {
    // Si pas de mode sélectionné, afficher l'écran de choix
    if (!creationMode) {
      return (
        <div className="space-y-4 py-4">
          <p className={`text-center text-base mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Alors, comment on fait pour te rendre <span className="text-pink-500 font-bold">irrésistible</span> ? 😏
          </p>
          
          {/* Option 1: À partir de ma photo */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => {
              setCreationMode('photo');
              setCurrentStep(0);
            }}
            className={`w-full p-6 rounded-2xl border-2 transition-all overflow-hidden relative ${
              isDarkMode
                ? 'border-pink-500/50 bg-gradient-to-br from-pink-500/10 to-purple-500/10 hover:border-pink-500'
                : 'border-pink-200 bg-gradient-to-br from-pink-50 to-purple-50 hover:border-pink-400'
            }`}
          >
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-pink-500 to-rose-500 flex items-center justify-center shadow-lg">
                <Camera className="w-8 h-8 text-white" />
              </div>
              <div className="text-left flex-1">
                <h3 className={`font-bold text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  📸 Ta plus belle photo !
                </h3>
                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  La magie te transforme en bombe 💣 Beau gosse / Belle gosse garanti !
                </p>
              </div>
              <div className="text-2xl">🔥</div>
            </div>
            <div className={`mt-3 text-xs ${isDarkMode ? 'text-pink-400' : 'text-pink-600'}`}>
              ⚡ Le plus rapide : juste ta photo et hop !
            </div>
          </motion.button>
          
          {/* Option 2: Création personnalisée */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => {
              setCreationMode('scratch');
              setCurrentStep(0);
            }}
            className={`w-full p-6 rounded-2xl border-2 transition-all overflow-hidden ${
              isDarkMode
                ? 'border-purple-500/50 bg-gradient-to-br from-purple-500/10 to-cyan-500/10 hover:border-purple-500'
                : 'border-purple-200 bg-gradient-to-br from-purple-50 to-cyan-50 hover:border-purple-400'
            }`}
          >
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center shadow-lg">
                <Wand2 className="w-8 h-8 text-white" />
              </div>
              <div className="text-left flex-1">
                <h3 className={`font-bold text-lg ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  🎨 Je crée de zéro !
                </h3>
                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  Choisis chaque détail : ton look de rêve, pixel par pixel !
                </p>
              </div>
              <div className="text-2xl">🎭</div>
            </div>
            <div className={`mt-3 text-xs ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>
              💎 Pour les perfectionnistes qui aiment tout contrôler !
            </div>
          </motion.button>
        </div>
      );
    }
    
    switch (steps[currentStep].id) {
      // 📸 NOUVELLE ÉTAPE : Photo
      case 'photo':
        return (
          <div className="space-y-4 py-2">
            {/* Zone photo */}
            <div className="relative">
              {showCamera ? (
                <div className="relative">
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    className="w-full aspect-square rounded-2xl object-cover border-4 border-pink-500"
                    style={{ transform: 'scaleX(-1)' }}
                  />
                  <canvas ref={canvasRef} className="hidden" />
                  <div className="flex gap-2 mt-3 justify-center">
                    <Button 
                      onClick={takePhoto} 
                      className="bg-gradient-to-r from-pink-500 to-rose-500 text-white"
                    >
                      <Camera className="w-4 h-4 mr-2" /> 📸 Capturer
                    </Button>
                    <Button onClick={stopCamera} variant="outline">
                      Annuler
                    </Button>
                  </div>
                </div>
              ) : userPhoto ? (
                <div className="relative">
                  <img
                    src={userPhoto}
                    alt="Ma photo"
                    className="w-full aspect-square rounded-2xl object-cover border-4 border-pink-500"
                  />
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white text-sm font-bold shadow-lg">
                    ✨ Magnifique !
                  </div>
                  <button
                    onClick={() => setUserPhoto(null)}
                    className="absolute top-2 right-2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              ) : (
                <div className={`w-full aspect-square rounded-2xl border-4 border-dashed flex flex-col items-center justify-center ${
                  isDarkMode ? 'border-gray-600 bg-gray-800/50' : 'border-gray-300 bg-gray-50'
                }`}>
                  <ImagePlus className={`w-16 h-16 mb-4 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} />
                  <p className={`text-center mb-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    Prends un selfie ou importe une photo de toi !
                  </p>
                  <div className="flex gap-3">
                    <Button 
                      onClick={startCamera}
                      className="bg-gradient-to-r from-pink-500 to-rose-500 text-white"
                    >
                      <Camera className="w-4 h-4 mr-2" /> Selfie
                    </Button>
                    <Button 
                      onClick={() => fileInputRef.current?.click()}
                      variant="outline"
                      className={isDarkMode ? 'border-purple-500 text-purple-400' : ''}
                    >
                      <Upload className="w-4 h-4 mr-2" /> Galerie
                    </Button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                      className="hidden"
                    />
                  </div>
                </div>
              )}
            </div>
            
            {/* Tips */}
            {!userPhoto && (
              <div className={`p-3 rounded-xl ${isDarkMode ? 'bg-purple-500/10 border border-purple-500/30' : 'bg-purple-50 border border-purple-200'}`}>
                <p className={`text-sm ${isDarkMode ? 'text-purple-300' : 'text-purple-700'}`}>
                  💡 <strong>Tips :</strong> Un bon éclairage + visage bien visible = meilleur résultat !
                </p>
              </div>
            )}
          </div>
        );
        
      case 'style':
        return (
          <div className="grid grid-cols-3 gap-3 max-h-[400px] overflow-y-auto p-1">
            {AVATAR_STYLES.map((s) => (
              <motion.button
                key={s.id}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => setStyle(s.id)}
                className={`relative p-4 rounded-xl border-2 transition-all overflow-hidden ${
                  style === s.id
                    ? 'border-purple-500 shadow-lg shadow-purple-500/30'
                    : isDarkMode
                      ? 'border-gray-700 hover:border-gray-600'
                      : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                {/* Background gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${s.color} opacity-20`} />
                
                {/* Content */}
                <div className="relative z-10">
                  <div className="text-2xl mb-1">{s.name.split(' ')[0]}</div>
                  <div className={`font-bold text-sm ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    {s.name.split(' ').slice(1).join(' ')}
                  </div>
                  <div className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    {s.description}
                  </div>
                </div>
                
                {/* Selected indicator */}
                {style === s.id && (
                  <motion.div 
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute top-2 right-2 w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center"
                  >
                    <Check className="w-4 h-4 text-white" />
                  </motion.div>
                )}
              </motion.button>
            ))}
          </div>
        );
      
      case 'gender':
        return (
          <div className="grid grid-cols-2 gap-6 py-4">
            {[
              { id: 'male', emoji: '👨', label: 'Homme', gradient: 'from-blue-500 to-cyan-500' },
              { id: 'female', emoji: '👩', label: 'Femme', gradient: 'from-pink-500 to-rose-500' },
            ].map((g) => (
              <motion.button
                key={g.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  setGender(g.id);
                  setHairStyle(HAIR_STYLES[g.id][0].id);
                }}
                className={`relative p-8 rounded-2xl border-2 transition-all overflow-hidden ${
                  gender === g.id
                    ? 'border-purple-500 shadow-xl'
                    : isDarkMode
                      ? 'border-gray-700 hover:border-gray-600'
                      : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                {/* Background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${g.gradient} ${
                  gender === g.id ? 'opacity-30' : 'opacity-10'
                }`} />
                
                {/* Content */}
                <div className="relative z-10 text-center">
                  <div className="text-7xl mb-3 drop-shadow-lg">{g.emoji}</div>
                  <div className={`font-bold text-xl ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    {g.label}
                  </div>
                </div>
                
                {/* Selected */}
                {gender === g.id && (
                  <div className="absolute top-3 right-3 w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center shadow-lg">
                    <Check className="w-5 h-5 text-white" />
                  </div>
                )}
              </motion.button>
            ))}
          </div>
        );
      
      case 'appearance':
        return (
          <div className="space-y-6 max-h-[400px] overflow-y-auto p-1">
            <ColorPicker 
              options={SKIN_TONES} 
              value={skinTone} 
              onChange={setSkinTone} 
              label="🎨 Couleur de peau" 
            />
            
            <ColorPicker 
              options={HAIR_COLORS} 
              value={hairColor} 
              onChange={setHairColor} 
              label="💇 Couleur de cheveux" 
            />
            
            <div className="space-y-2">
              <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                💇 Style de coiffure
              </label>
              <OptionGrid 
                options={HAIR_STYLES[gender]} 
                value={hairStyle} 
                onChange={setHairStyle}
                columns={4}
              />
            </div>
            
            <ColorPicker 
              options={EYE_COLORS} 
              value={eyeColor} 
              onChange={setEyeColor} 
              label="👁️ Couleur des yeux" 
            />
          </div>
        );
      
      case 'extras':
        return (
          <div className="space-y-6 max-h-[400px] overflow-y-auto p-1">
            {/* Mood */}
            <div className="space-y-2">
              <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                😊 Expression / Humeur
              </label>
              <div className="flex flex-wrap gap-2">
                {MOODS.map((m) => (
                  <button
                    key={m.id}
                    onClick={() => setMood(m.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                      mood === m.id
                        ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                        : isDarkMode
                          ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {m.name}
                  </button>
                ))}
              </div>
            </div>
            
            {/* Accessories */}
            <div className="space-y-2">
              <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                ✨ Accessoires (optionnel)
              </label>
              <div className="flex flex-wrap gap-2">
                {ACCESSORIES.map((acc) => (
                  <button
                    key={acc.id}
                    onClick={() => toggleAccessory(acc.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                      selectedAccessories.includes(acc.id)
                        ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg'
                        : isDarkMode
                          ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {acc.name}
                  </button>
                ))}
              </div>
            </div>
            
            {/* Custom description */}
            <div className="space-y-2">
              <label className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                ✏️ Description personnalisée (optionnel)
              </label>
              <textarea
                value={customDescription}
                onChange={(e) => setCustomDescription(e.target.value)}
                placeholder="Ex: avec un sourire mystérieux, dans une forêt enchantée, avec des tatouages tribaux..."
                className={`w-full p-3 rounded-lg border-2 resize-none ${
                  isDarkMode 
                    ? 'bg-gray-800 border-gray-700 text-white placeholder-gray-500' 
                    : 'bg-white border-gray-200 text-gray-900 placeholder-gray-400'
                }`}
                rows={3}
              />
            </div>
          </div>
        );
      
      case 'generate':
        return (
          <div className="text-center py-6">
            {!generatedAvatar && !isGenerating && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="space-y-6"
              >
                {/* Mode Photo : Afficher photo source + style */}
                {creationMode === 'photo' && userPhoto && (
                  <div className="flex items-center justify-center gap-4 mb-4">
                    <div className="relative">
                      <img
                        src={userPhoto}
                        alt="Ma photo"
                        className="w-24 h-24 rounded-xl object-cover border-2 border-pink-500"
                      />
                      <div className="absolute -bottom-1 -right-1 text-lg">📸</div>
                    </div>
                    <div className="text-3xl">→</div>
                    <div className={`w-24 h-24 rounded-xl flex items-center justify-center border-2 border-purple-500 ${
                      isDarkMode ? 'bg-purple-500/20' : 'bg-purple-50'
                    }`}>
                      <span className="text-3xl">{AVATAR_STYLES.find(s => s.id === style)?.name.split(' ')[0]}</span>
                    </div>
                  </div>
                )}
                
                {/* Résumé des choix - Mode Scratch */}
                {creationMode === 'scratch' && (
                  <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
                    <h4 className={`font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      📋 Récapitulatif
                    </h4>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                        Style: <span className="font-medium text-purple-400">{AVATAR_STYLES.find(s => s.id === style)?.name}</span>
                      </div>
                      <div className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                        Genre: <span className="font-medium text-purple-400">{gender === 'male' ? '👨 Homme' : '👩 Femme'}</span>
                      </div>
                      <div className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                        Humeur: <span className="font-medium text-purple-400">{MOODS.find(m => m.id === mood)?.name}</span>
                      </div>
                      <div className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                        Cheveux: <span className="font-medium text-purple-400">{HAIR_COLORS.find(h => h.id === hairColor)?.name}</span>
                      </div>
                    </div>
                  </div>
                )}
                
                {/* Résumé Mode Photo */}
                {creationMode === 'photo' && (
                  <div className={`p-4 rounded-xl ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
                    <h4 className={`font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      🎨 Transformation magique
                    </h4>
                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Ta photo sera analysée puis transformée par magie en style <span className="font-bold text-purple-400">{AVATAR_STYLES.find(s => s.id === style)?.name}</span>
                    </p>
                  </div>
                )}
                
                <Button
                  onClick={creationMode === 'photo' ? generateAvatarFromPhoto : generateAvatar}
                  data-testid="btn-generate-avatar"
                  disabled={creationMode === 'photo' && !userPhoto}
                  className="w-full py-6 text-lg bg-gradient-to-r from-purple-600 via-pink-500 to-rose-500 hover:from-purple-700 hover:via-pink-600 hover:to-rose-600 text-white shadow-xl disabled:opacity-50"
                >
                  <Wand2 className="w-6 h-6 mr-2" />
                  {creationMode === 'photo' ? '📸 Transformer ma photo !' : '✨ Abracadabra ! ✨'}
                </Button>
                
                <p className={`text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                  {creationMode === 'photo' 
                    ? 'La magie analyse ta photo puis crée ton avatar (45-90 sec)'
                    : 'La génération peut prendre 30-60 secondes'
                  }
                </p>
              </motion.div>
            )}
            
            {isGenerating && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="space-y-6"
              >
                {/* Animation de chargement */}
                <div className="relative w-48 h-48 mx-auto">
                  {/* Cercles animés */}
                  <div className="absolute inset-0 rounded-full border-4 border-purple-500/30 animate-ping" />
                  <div className="absolute inset-4 rounded-full border-4 border-pink-500/40 animate-ping" style={{ animationDelay: '0.2s' }} />
                  <div className="absolute inset-8 rounded-full border-4 border-rose-500/50 animate-ping" style={{ animationDelay: '0.4s' }} />
                  
                  {/* Centre */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-24 h-24 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-rose-500 flex items-center justify-center shadow-2xl">
                      <Sparkles className="w-12 h-12 text-white animate-pulse" />
                    </div>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <h3 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    🪄 La magie opère...
                  </h3>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    Patience, la magie opère ! ✨
                  </p>
                </div>
                
                {/* Barre de progression simulée */}
                <div className="w-full max-w-xs mx-auto">
                  <div className={`h-2 rounded-full overflow-hidden ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                    <motion.div
                      initial={{ width: '0%' }}
                      animate={{ width: '100%' }}
                      transition={{ duration: 45, ease: 'linear' }}
                      className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500"
                    />
                  </div>
                </div>
              </motion.div>
            )}
            
            {generatedAvatar && (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="space-y-6"
              >
                {/* Avatar généré */}
                <div className="relative inline-block">
                  <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500 rounded-2xl blur-lg opacity-75" />
                  <img
                    src={generatedAvatar.imageData}
                    alt="Avatar généré"
                    className="relative w-64 h-64 rounded-2xl object-cover shadow-2xl"
                  />
                  {/* Badge du style */}
                  <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-bold shadow-lg">
                    {generatedAvatar.styleName}
                  </div>
                </div>
                
                <div className="flex gap-3 justify-center">
                  <Button
                    onClick={generateAvatar}
                    variant="outline"
                    className={isDarkMode ? 'border-gray-600 text-gray-300' : ''}
                    data-testid="btn-regenerate-avatar"
                  >
                    <RefreshCw className="w-4 h-4 mr-2" />
                    Régénérer
                  </Button>
                  
                  <Button
                    onClick={saveToProfile}
                    className="bg-gradient-to-r from-green-500 to-emerald-500 text-white hover:from-green-600 hover:to-emerald-600"
                    data-testid="btn-save-avatar"
                  >
                    <Save className="w-4 h-4 mr-2" />
                    Utiliser cet avatar 💜
                  </Button>
                </div>
              </motion.div>
            )}
          </div>
        );
      
      default:
        return null;
    }
  };

  // Panel historique
  const HistoryPanel = () => (
    <motion.div
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      className={`absolute inset-0 z-50 ${isDarkMode ? 'bg-gray-900' : 'bg-white'} overflow-hidden rounded-2xl`}
    >
      <div className="bg-gradient-to-r from-purple-600 via-pink-500 to-rose-500 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <History className="w-5 h-5 text-white" />
            <h3 className="font-bold text-white">Mes avatars</h3>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowHistory(false)}
            className="text-white hover:bg-white/20"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>
      </div>
      
      <div className="p-4 max-h-[500px] overflow-y-auto">
        {avatarHistory.length === 0 ? (
          <div className="text-center py-8">
            <Sparkles className={`w-12 h-12 mx-auto mb-3 ${isDarkMode ? 'text-gray-600' : 'text-gray-300'}`} />
            <p className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
              Aucun avatar généré pour l'instant
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {avatarHistory.map((avatar, idx) => (
              <motion.div
                key={avatar.avatarId || idx}
                whileHover={{ scale: 1.03 }}
                className={`relative rounded-xl overflow-hidden cursor-pointer ${
                  isDarkMode ? 'bg-gray-800' : 'bg-gray-100'
                }`}
                onClick={() => {
                  setGeneratedAvatar({
                    avatarId: avatar.avatarId,
                    imageData: avatar.imageData,
                    style: avatar.style,
                    styleName: AVATAR_STYLES.find(s => s.id === avatar.style)?.name || avatar.style
                  });
                  setCurrentStep(4); // Go to generate step
                  setShowHistory(false);
                }}
              >
                <img
                  src={avatar.imageData}
                  alt={`Avatar ${idx + 1}`}
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <span className="text-white text-xs font-medium">
                    {AVATAR_STYLES.find(s => s.id === avatar.style)?.name || avatar.style}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );

  return (
    <div className={`relative rounded-2xl overflow-hidden ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`} data-testid="avatar-creator">
      {/* Header */}
      <div className="bg-gradient-to-r from-purple-600 via-pink-500 to-rose-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white flex items-center gap-2">
              {creationMode === 'photo' ? <Camera className="w-6 h-6" /> : <Wand2 className="w-6 h-6" />}
              {!creationMode ? '💜 Deviens Irrésistible' : creationMode === 'photo' ? '📸 Ta Version Canon' : '🎨 Ton Avatar de Rêve'}
            </h2>
            <p className="text-white/80 text-sm">
              {!creationMode 
                ? 'Révèle ton charme caché ! ✨'
                : creationMode === 'photo' 
                  ? 'La magie te transforme en bombe 🔥' 
                  : 'Crée ton look parfait, pixel par pixel !'
              }
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowHistory(true)}
              className="text-white hover:bg-white/20"
              data-testid="btn-avatar-history"
            >
              <History className="w-4 h-4 mr-1" />
              Mes créations
            </Button>
          </div>
        </div>
        
        {/* Progress bar - seulement si mode sélectionné */}
        {creationMode && (
          <div className="mt-4 flex gap-1">
            {steps.map((_, idx) => (
              <div
                key={idx}
                className={`h-1.5 flex-1 rounded-full transition-all ${
                  idx <= currentStep ? 'bg-white' : 'bg-white/30'
                }`}
              />
            ))}
          </div>
        )}
      </div>

      {/* Step Title - seulement si mode sélectionné */}
      {creationMode && (
        <div className="px-4 pt-4 text-center">
          <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            {steps[currentStep].title}
          </h3>
          <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            {steps[currentStep].subtitle}
          </p>
        </div>
      )}

      {/* Step Content */}
      <div className="p-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={creationMode ? `${creationMode}-${currentStep}` : 'mode-selection'}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            {renderStepContent()}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Navigation */}
      <div className={`p-4 flex gap-3 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
        <Button
          variant="outline"
          onClick={() => {
            if (!creationMode) {
              onClose?.();
            } else if (currentStep > 0) {
              setCurrentStep(currentStep - 1);
            } else {
              // Retour au choix du mode
              setCreationMode(null);
              setUserPhoto(null);
              setGeneratedAvatar(null);
            }
          }}
          className="flex-1"
          disabled={isGenerating}
        >
          <ChevronLeft className="w-4 h-4 mr-2" />
          {!creationMode ? 'Annuler' : currentStep > 0 ? 'Retour' : 'Changer de mode'}
        </Button>
        
        {creationMode && currentStep < steps.length - 1 && (
          <Button
            onClick={() => setCurrentStep(currentStep + 1)}
            className="flex-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600"
            disabled={creationMode === 'photo' && steps[currentStep].id === 'photo' && !userPhoto}
          >
            Suivant
            <ChevronRight className="w-4 h-4 ml-2" />
          </Button>
        )}
      </div>

      {/* History Panel */}
      <AnimatePresence>
        {showHistory && <HistoryPanel />}
      </AnimatePresence>
    </div>
  );
}

// Export pour compatibilité
export { AvatarCreator };
